import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "logo",
  src: "/img/icon.png",
  height: "36",
  class: "mr-2"
}, null, -1)

import Message from 'primevue/message'
import {useUserStore} from "@/stores/UserStore";
import {computed, inject, ref} from "vue";
import Menubar from "primevue/menubar";
import UserInfo from "@/components/blocks/UserInfo.vue";
import {useI18n} from "vue-i18n";
import {useUserInfo} from "@/stores/InfoStore";
import {AxiosStatic} from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useUserStore()

const i18n = useI18n()

const noPrimaryCompany = computed(() => {
  return store.userDetail.company === undefined || store.userDetail.company === null
})

const items = ref([
  {
    label: i18n.t('dashboard'), icon: 'pi pi-fw pi-calendar', to: '/private/dashboard'
  },
  {
    label: 'Vyúčtování',
    icon: 'pi pi-fw pi-money-bill',
    items: [
      {label: 'Vyúčtování', to: '/private/billing'},
      {
        label: 'Faktury', items: [
          {label: 'Přehled faktur', to: '/private/invoices'},
          {label: 'Přidat fakturu', to: '/private/invoices-add'}
        ]
      },
      {label: 'DPH', to: '/private/dph'},
      {label: 'Daně', to: '/private/tax'},
    ]
  },
  {
    label: 'Nastavení', icon: 'pi pi-fw pi-wrench',
    items: [
      {label: 'Správa společností', to: '/private/companies'},
      {label: 'Správa objednávek', to: '/private/requisition'},
      {label: 'Správa projektů', to: '/private/project'},
      {label: 'Sazby', to: '/private/rate'},
      {label: 'Zápis do externích systémů', to: '/private/writers'}
    ]
  },
  {
    label: 'Statistic', icon: 'pi pi-fw pi-wrench',
    items: [
      {label: 'Money flow', to: '/private/money-flow'},
      {label: 'Payments', to: '/private/payments'}
    ]
  }

])


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(store).userDetail.userName !== 'anonymous')
      ? (_openBlock(), _createBlock(_unref(Menubar), {
          key: 0,
          model: items.value
        }, {
          start: _withCtx(() => [
            _hoisted_1
          ]),
          end: _withCtx(() => [
            _createVNode(UserInfo)
          ]),
          _: 1
        }, 8, ["model"]))
      : _createCommentVNode("", true),
    (_unref(noPrimaryCompany) && _unref(store).userDetail.userName !== 'anonymous')
      ? (_openBlock(), _createBlock(_unref(Message), {
          key: 1,
          closable: false,
          severity: "warn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" You do not have set primary company. "),
            _createVNode(_component_router_link, {
              style: {"color":"#343434"},
              to: "/private/companies"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Please add company here")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}
}

})